import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { json } from 'express';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss']
})
export class SettingComponent implements OnInit {

  constructor(private sharedService: SharedService) { }

  async ngOnInit() {
    await this.load();
  }

  settings: any[];
  configs: any[];

  private async load() {
    this.settings = await this.sharedService.getSetting();
    this.settings.forEach(_ => _._json = JSON.stringify(_.Value, undefined, 4));
    this.configs = await this.sharedService.getConfig();
    this.configs.forEach(_ => _.Json = JSON.stringify(JSON.parse(_.Json), undefined, 4));
  }

  newSetting: any = {
    _json: "{\n}"
  };
  async save(setting: any) {
    await this.sharedService.saveSetting(setting.Id, JSON.parse(setting._json));
    this.newSetting = {};
    await this.load();
  }

  newConfig: any = {};
  async setConfig(config: any) {
    config.Json = JSON.stringify(JSON.parse(config.Json));
    await this.sharedService.setConfigJson(config);
    await this.load();
    this.newConfig = {};
  }
}
